import login from "./login";

const userAuthModule = {
  namespaced: true,
  modules: { login },
};

export default userAuthModule;
